'use strict';

(function () {
  'use strict';
  /**
   * This directive allows a temporary preview image to appear in the place of images, until the real image loads.
   * This has a hard-coded header that should work for all the preview images.
   * If parent component has scope.ac.externalLazyLoad set to true, imagePreview expects that an external lazy loader will finalize the loading of an image.
   * - Used in activities listing page.
   */

  angular.module('msUtility').directive('imgPreview', ImgPreview);

  ImgPreview.$inject = ['$parse', '$log', '$timeout'];

  // hard-coded header to be used in all the previews
  var header = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDABsSFBcUERsXFhceHBsgKEMrKCUlKFI6PjBDYVVmZF9VXVxreJmCa3GRc1xdhbaHkZ6jrK2sZ4C8yrunyJmorKX/2wBDARweHigjKE4rK06lbl1upaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaX/wAARCAAGAAYDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAP';

  function ImgPreview($parse, $log, $timeout) {
    return {
      restrict: 'E',
      scope: false,
      link: link
    };

    function link(scope, ele, attr) {
      var base64preview = scope.$eval(attr.previewSrc);
      var imagePreview = renderImagePreview(base64preview, ele);
      var imageSrc = setImgixParams(scope.$eval(attr.imageSrc));
      var altText = $parse(attr.imageAlt)(scope);

      if (_.isUndefined(scope) || _.isUndefined(scope.ac) || _.isUndefined(scope.ac.externalLazyLoad)) {
        // Load images normally if no external lazy loader
        var image = new Image();

        image.onload = function () {
          imagePreview.after(image);

          $timeout(function () {
            image.classList.add('show');
          }, 100);
        };
        image.onerror = function () {
          $log.warn('Image failed to load ', imageSrc);
        };

        image.src = imageSrc;
        image.alt = altText;
      } else {
        // Set attributes for external lazy loader use
        imagePreview[0].setAttribute('data-image-src', imageSrc);
        imagePreview[0].setAttribute('data-image-alt', altText);
      }
    }

    function renderImagePreview(base64Img, ele) {
      var backgroundImageCss = 'background-image: url(' + header + base64Img + ')';
      var imagePreviewTemplate = angular.element('<div class="image-preview" style="' + (base64Img ? backgroundImageCss : '') + '"></div>');
      if (!base64Img) {
        $log.warn('No image preview for image.');
      }
      ele.append(imagePreviewTemplate);
      return imagePreviewTemplate;
    }

    function setImgixParams(imageSrc) {
      // Apply imgix params only to imgix images
      var imgixRegex = new RegExp('imgix.net');
      // Square crop 400px x 400px
      var imgixParams = '?fit=crop&w=400&h=400';

      if (imgixRegex.test(imageSrc)) {
        return imageSrc.split('?')[0] + imgixParams;
      }

      return imageSrc;
    }
  }
})();